import { AxiosRequestConfig } from "axios";
import { api } from "../api-instance";
import {
  Cluster,
  PostCluster,
  PutCluster,
} from "../../../modules/clusters/types";

const ROUTE = "/clusters";

export async function getClusters(): Promise<{
  // page: number = 1,c
  // search: string = "",
  // params?: Partial<Cluster>,
  // limit: number = 1000
  data: Cluster[];
  total: number;
}> {
  //TODO: Aplicar parâmetros quando a paginação e ordenação do Back End estiver finalizada

  const config: AxiosRequestConfig = {
    // params: {
    //   _page: page,
    //   _limit: limit,
    //   q: search,
    //   ...params,
    // },
  };
  const result = await api.get<Cluster[]>(ROUTE, config);
  return {
    data: result.data,
    total: parseInt(result.headers["x-total-count"]),
  };
}
export async function getCluster(id: string) {
  const result = await api.get<Cluster>(`${ROUTE}/${id}`);
  return result.data;
}
export async function postCluster(usina: PostCluster): Promise<{ id: string }> {
  const result = await api.post(ROUTE, usina);
  return result.data;
}
export async function patchCluster(usina: PutCluster): Promise<{ id: string }> {
  const result = await api.put(`${ROUTE}/${usina.clusterId}`, usina);
  return result.data;
}

export async function deleteCluster(id: string): Promise<{ id: string }> {
  const result = await api.delete(`${ROUTE}/${id}`);
  return result.data;
}
